import React from 'react';
import { TOKEN_POST, TOKEN_VALIDATE_POST, USER_GET } from './Api';
import { useNavigate } from 'react-router-dom';

export const UserContext = React.createContext();

export const UserStorage = ({ children }) => {
  const [data, setData] = React.useState(null);
  const [login, setLogin] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const navigate = useNavigate();

  const userLogout = React.useCallback(
    async function () {
      setData(null);
      setError(null);
      setLoading(false);
      setLogin(false);
      window.localStorage.removeItem('token');
      navigate('/login');
    },
    [navigate],
  );

  async function setNull() {
    setData(null);
    setError(null);
    setLoading(false);
    setLogin(false);
    window.localStorage.removeItem('token');
    navigate('/login');
  }

  async function getUser(token) {
    //const { url, options } = USER_GET(token);
    //cons//t response = await fetch(url, options);
    //const json = await response.json();
    //setData(json);
    //setLogin(true);
  }

  async function userLogin(username, email, password) {
    try {
    //  setError(null);
    //  setLoading(true);
    //  const { url, options } = TOKEN_POST({ email, password});
    //  const tokenRes = await fetch(url, options);
    //  if (!tokenRes.ok) throw new Error(`Error: ${tokenRes.statusText}`);
      //const { token } = await tokenRes.json();
   //   const user = await tokenRes.json();
   //   window.localStorage.setItem('token', user.token);
   //   await getUser(user.token);
    //  navigate('/conta');
    } catch (err) {
      setError(err.message);
      setLogin(false);
    } finally {
      setLoading(false);
    }
  }

  React.useEffect(() => {
    async function autoLogin() {
      const token = window.localStorage.getItem('token');
      if (token) {
        try {
          //setError(null);
          //setLoading(true);
          //const { url, options } = TOKEN_VALIDATE_POST(token);
          //const response = await fetch(url, options);
          //const json = await response.json();
          //if (!response.status == 200) throw new Error('Token inválido');
          //await getUser(token);
        } catch (err) {
          //userLogout();
        } finally {
          //setLoading(false);
        }
      } else {
        //setLogin(false);
      }
    }
    autoLogin();
  }, [userLogout]);

  return (
    <UserContext.Provider
      value={{ userLogin, setNull, userLogout, data, error, loading, login }}
    >
      {children}
    </UserContext.Provider>
  );
};
